var buttons = document.getElementsByClassName("flipper");

for (var i = 0; i < buttons.length; i++) {
  buttons[i].addEventListener("click", flip);
}

function flip(e) {
  e.currentTarget.classList.toggle("flipped");
}
